// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import Button from '@ta/core-ui.button';
import Localize from '@ta/platform.i18n';

type Props = {|
  onBack?: (SyntheticEvent<HTMLButtonElement>) => mixed,
|};

const BackButton = ({ onBack }: Props) => (
  <Button theme="secondary" onClick={onBack} fullWidth>
    <Localize id="com_fyf_p2_011" /> {/* Back */}
  </Button>
);

export default BackButton;
